_ = require 'underscore'
CustomFieldOptionList = require 'app/scripts/models/collections/custom-field-option-list'
TrelloModel = require 'app/scripts/models/internal/trello-model'
Util = require 'app/scripts/lib/util'

CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId

class CustomField extends TrelloModel
  typeName: 'CustomField'
  urlRoot: '/1/customFields'

  @types = ['checkbox', 'date', 'list', 'number', 'text']

  @lazy
    optionList: ->
      new CustomFieldOptionList().syncSubModels(@, 'options', true)

  getBoard: ->
    @modelCache.get('Board', @get('idModel'))

  getOption: (idOption) -> @optionList.get(idOption)

  getOptionByCId: (cid) -> _.find @optionList.models, (o) -> o.cid == cid

  editable: ->
    @visible() && @getBoard().editable()

  visible: ->
    @pluginEnabled()

  pluginEnabled: ->
    @getBoard().isPluginEnabled(CUSTOM_FIELDS_ID)

  icon: ->
    switch @get('type')
      when 'text' then 'text'
      when 'number' then 'number'
      when 'date' then 'calendar'
      when 'checkbox' then 'selection-mode'
      when 'list' then 'dropdown-options'
      else ''

  calcPos: (index, option) ->
    Util.calcPos(index, @optionList, option)

  move: (index) ->
    @update('pos', Util.calcPos(index, @collection, @))
    @collection.sort({ silent: false })
    return

  isList: ->
    @get('type') == 'list'

  isSortable: ->
    @get('type') == 'number' || @get('type') == 'date'

  toggleDisplay: ->
    @update("display/cardFront", !@get('display')?.cardFront)

module.exports = CustomField
